import type { AgentTask, BankTransaction, PullRequest, Receipt } from '../../types/db';

export const pullRequests: PullRequest[] = [
  {
    id: 'pr-142',
    number: 142,
    repo: 'project-x',
    title: 'Fix build na dependency-update',
    branch: 'fix/nachtelijke-build',
    files: [
      { path: 'src/api/client.ts', additions: 14, deletions: 6 },
      { path: 'src/api/client.test.ts', additions: 8, deletions: 2 },
      { path: 'package.json', additions: 2, deletions: 1 },
    ],
    tests: { passed: 48, failed: 0 },
    status: 'open',
  },
];

export const receipts: Receipt[] = [
  { id: 'r-1', vendor: 'Kantoorhandel Utrecht', date: 'gisteren', amount: 59.95, vatRate: 0.21, bankTxId: 'tx-1', confidence: 0.97 },
  { id: 'r-2', vendor: 'Hosting project X', date: 'gisteren', amount: 24.25, vatRate: 0.21, bankTxId: 'tx-2', confidence: 0.92 },
];

export const bankTransactions: BankTransaction[] = [
  { id: 'tx-1', date: 'gisteren', description: 'KANTOORHANDEL UTRECHT', amount: -59.95 },
  { id: 'tx-2', date: 'gisteren', description: 'HOSTING PROJECT X', amount: -24.25 },
];

export const agentTasks: AgentTask[] = [
  {
    id: 't-code',
    agent: 'code',
    title: 'Nachtelijke build project X',
    stepLabel: 'tests draaien',
    step: 4,
    totalSteps: 5,
    elapsed: '06:12',
    where: 'lokaal',
    status: 'bezig',
    pace: 0.9,
    model: 'Qwen 32B Coder',
    events: ['tests gestart', '2 fouten gevonden', 'fix voorgesteld'],
    upcoming: [
      { event: 'fix toegepast op branch' },
      { event: '48 van 48 tests geslaagd', step: 5, stepLabel: 'PR #142 bijwerken' },
      { event: 'PR #142 bijgewerkt' },
    ],
  },
  {
    id: 't-mail',
    agent: 'mail',
    title: 'Inbox samenvatten',
    stepLabel: '12 mails, 3 vragen om antwoord',
    step: 2,
    totalSteps: 3,
    elapsed: '01:40',
    where: 'cloud',
    status: 'bezig',
    pace: 0.55,
    model: 'Claude',
    events: ['12 mails gelezen', '3 vragen om antwoord', 'concept voor klant Bakker klaar'],
    upcoming: [
      { event: '1 nieuwsbrief gearchiveerd' },
      { event: 'samenvatting klaar', step: 3, stepLabel: 'samenvatting klaar' },
    ],
  },
  {
    id: 't-slack',
    agent: 'slack',
    title: '#project-x volgen',
    stepLabel: 'kanaal volgen',
    step: 1,
    totalSteps: 2,
    elapsed: '00:20',
    where: 'lokaal',
    status: 'bezig',
    pace: 0.35,
    model: 'Llama 3.1 8B',
    events: ['kanaal geopend', '14 berichten gelezen'],
    upcoming: [{ event: 'draad over de release gevolgd' }],
  },
  {
    id: 't-studio',
    agent: 'studio',
    title: 'Beeld voor de nieuwe landingspagina',
    stepLabel: 'GPU-brein wordt gewekt (~40 s)',
    step: 1,
    totalSteps: 3,
    elapsed: '00:04',
    where: 'lokaal',
    status: 'bezig',
    pace: 0.28,
    model: 'FLUX.1 dev',
    events: ['prompt opgesteld', 'GPU-brein wordt gewekt'],
  },
  {
    id: 't-boekhouding',
    agent: 'boekhouding',
    title: 'Bonnen koppelen aan bank',
    stepLabel: '2 van 2 gekoppeld, wacht op ok',
    step: 2,
    totalSteps: 2,
    elapsed: '00:12',
    where: 'lokaal',
    status: 'wacht',
    pace: 0.2,
    model: 'Qwen 32B',
    events: ['2 bonnen gevonden', '2 van 2 gekoppeld'],
  },
  {
    id: 't-initiatief',
    agent: 'initiatief',
    title: 'Voorbereiding meeting Lisa',
    stepLabel: 'klaar',
    step: 3,
    totalSteps: 3,
    elapsed: '02:05',
    where: 'lokaal',
    status: 'klaar',
    pace: 0,
    model: 'Qwen 32B',
    events: ['bedrijf opgezocht', 'mails samengevat', 'open vraag gevonden'],
  },
];
